import { Injectable, inject } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { NetworkConstants, HuntingEvent, ContextMembership } from 'diwimamodelweb/lib';
import { deepCopy, diffObject, removeUndefined, updatesToFirestoreUpdates } from 'diwimamodelweb/lib/utils/obejct-diff';
import { BehaviorSubject, combineLatest, forkJoin, Subject, Subscription } from 'rxjs';
import { distinctUntilChanged, skipWhile, take, takeUntil } from 'rxjs/operators';
import { SettingsService } from './settings.service';
import { TransactionLogService } from './transaction-log.service';
import { UserService } from './user.service';
import * as deepEqual from 'deep-equal'
import { HuntingDistrictService } from './hunting-district.service';
import { Firestore, collection, collectionData, query, where, getDocs, doc, updateDoc, setDoc, deleteDoc } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class EventsService {
  private Ifirestore = inject(Firestore);
  ngUnsubscribe: Subject<void> = new Subject<void>();
  subscriptions: Map<string, Subscription> = new Map([])
  eventsSubject$ = new BehaviorSubject<HuntingEvent[]>(undefined)
  subbedContext: string|undefined = undefined

  constructor(
    private firestore: AngularFirestore,
    private settingsService: SettingsService,
    private userService: UserService,
    private transactionLogService: TransactionLogService,
    private huntingDistrictService: HuntingDistrictService
  ) {
    // To check for "outdated" data 
    forkJoin(
      [
      this.eventsSubject$.pipe(skipWhile(el => !el)),
      this.huntingDistrictService.huntindDistrictSubject$.pipe(skipWhile(el => !el))
      ]
    )
    .subscribe(([events, districts]) => {
      events?.forEach(event => {
        if (event.huntingDistrictId && !event.huntingDistrictName) {
          const dist = districts?.find(district => district.identifier == event.huntingDistrictId)
          if (dist) event.huntingDistrictName = dist.name
        }
      })
    })
  }

  observeData(contextId) {
    if (this.subbedContext == contextId) return 
    if (this.subscriptions.get('1')) this.subscriptions.get('1').unsubscribe()
    if (!!this.eventsSubject$.value) this.eventsSubject$.next(undefined)
    const sub = this.observeEvents(contextId)
    this.subscriptions.set('1', sub)
    this.subbedContext = contextId
  }

  async removeSubs(): Promise<void> {
    this.ngUnsubscribe.next()
    this.subbedContext = undefined
    this.subscriptions.forEach((value) => {
      value.unsubscribe()
    })
    return Promise.resolve()
  }

  observeEvents(contextId: string) {
    // return this.firestore.collection(NetworkConstants.COLLECTION_EVENT, ref => ref.where('contextId', '==', contextId)).valueChanges()
    const path = `${NetworkConstants.COLLECTION_EVENT}`
    const collRef = collection(this.Ifirestore, path);
    const q = query(collRef, where('contextId', '==', contextId));
    return collectionData(q)
      .pipe(
        distinctUntilChanged((prev, curr) => deepEqual(prev, curr)),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((districts: any[]) => {
        
        var list: HuntingEvent[] = []
        districts.forEach((el) => {
          const district = new HuntingEvent()
          district.setFromAny(el)
          list.push(district)
        })
        this.eventsSubject$.next(list)
      })
  }

  updateExistingEvent(oldObj, newObj): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const updates = diffObject(oldObj, newObj, {})
      const map = updatesToFirestoreUpdates(updates)
      if(map.active){
        if(map.active._methodName){
          map.active=false
        }
      }
      try {
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const list = await this.transactionLogService.determineDiff(user, updates, newObj.identifier, NetworkConstants.COLLECTION_EVENT)
        map['updateTimestamp'] = new Date()
        const docRef = doc(this.Ifirestore,NetworkConstants.COLLECTION_EVENT, newObj.identifier )
        await updateDoc( docRef, map)
        // await this.firestore.collection(NetworkConstants.COLLECTION_EVENT).doc(newObj.identifier).update(map)
        // if successfull save transactionlog..
        await this.transactionLogService.saveTransactionLog(list)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  createEvent(newEvent: any): Promise<void> {
    return new Promise(async (resolve, reject) => {
      // const docRef = this.firestore.collection(NetworkConstants.COLLECTION_EVENT).doc().ref
      const docRef = doc(collection(this.Ifirestore, NetworkConstants.COLLECTION_EVENT))
      const now = new Date()
      newEvent['identifier'] = docRef.id
      newEvent['creationDate'] = now
      newEvent['updateTimestamp'] = now
      try {
        const contextId = this.settingsService.selectedUserContext$.value.identifier
        if (!contextId) reject("No context id")
        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const logItems = this.transactionLogService.createLog(user, newEvent.identifier, NetworkConstants.COLLECTION_EVENT, newEvent)
        newEvent['contextId'] = contextId
        // await this.firestore.collection(NetworkConstants.COLLECTION_EVENT).doc(newEvent.identifier).set({...newEvent})
        await setDoc(docRef,{...newEvent} )
        await this.transactionLogService.saveTransactionLog(logItems)
        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  async deleteHuntingEvent(huntingEvent: HuntingEvent): Promise<void>{
    return new Promise(async (resolve,reject ) =>{
      try{
        const huntingTodelete = deepCopy(huntingEvent, huntingEvent.replacerFn)
        const dataToDelete = removeUndefined(huntingTodelete)
        

        const user = await this.userService.user$.pipe(take(1)).toPromise()
        const transactionLogItem = this.transactionLogService.deleteDocumentLog(
          user,
          huntingEvent.identifier,
          NetworkConstants.COLLECTION_EVENT,
          dataToDelete
        )
        const promiseArray = []
        promiseArray.push(
          this.transactionLogService.saveTransactionLog([transactionLogItem])
        )
        const docRef = doc(this.Ifirestore, NetworkConstants.COLLECTION_EVENT, huntingEvent.identifier)
        const delOperation = await deleteDoc( docRef)
        // const delOperation = this.firestore.collection(NetworkConstants.COLLECTION_EVENT).doc(huntingEvent.identifier).delete()
        promiseArray.push(delOperation)
        resolve()

      }catch(error){
        reject(error)
      }
    })

  }
}


